var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportsMainMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_98447",
    "data-name": "Group 98447",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.281,
    height: 19.537,
    viewBox: "0 0 16.281 19.537",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-76451987"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3230",
    "data-name": "Rectangle 3230",
    width: 16.281,
    height: 19.538,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10087",
    "data-name": "Group 10087",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-76451987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13078",
    "data-name": "Path 13078",
    d: "M12.211,11.4a.814.814,0,0,1-.814.814H4.884a.814.814,0,0,1,0-1.628H11.4a.814.814,0,0,1,.814.814M8.955,13.84H4.884a.814.814,0,0,0,0,1.628h4.07a.814.814,0,0,0,0-1.628m7.327-5.3v6.932a4.075,4.075,0,0,1-4.07,4.07H4.07A4.075,4.075,0,0,1,0,15.468V4.071A4.075,4.075,0,0,1,4.07,0H7.746a5.664,5.664,0,0,1,4.03,1.669l2.836,2.838a5.659,5.659,0,0,1,1.67,4.029M10.624,2.82a4.077,4.077,0,0,0-.856-.635V5.7a.814.814,0,0,0,.814.814H14.1a4.056,4.056,0,0,0-.636-.855Zm4.029,5.716c0-.134-.026-.263-.038-.395H10.583A2.442,2.442,0,0,1,8.141,5.7V1.667c-.132-.012-.261-.038-.395-.038H4.07A2.442,2.442,0,0,0,1.628,4.071v11.4A2.442,2.442,0,0,0,4.07,17.91h8.141a2.442,2.442,0,0,0,2.442-2.442Z",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsMainMenuIcon);
export default __webpack_public_path__ + "static/media/reports-main-menu-icon.23059857848629a7578d0ee79d9085d7.svg";
export { ForwardRef as ReactComponent };